import React from "react";
import useStyles from "./VendorDetail.css";
import translation from "../../../i18n/i18.json";
import { Checkbox, Grid, TextField } from "@material-ui/core";
import { VendorCreateState } from "../../../reducers/vendor/VendorCreateReducer";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../reducers";
import { VendorBlockinViewData } from "../../../models/VendorBlocking/VendorBlockinViewData";
import { VendorRequestViewMode, 
  FileUploadTypes,
  DropdownOptions_VendorBlocing_Reason } from "../../../constants/AppConstants";
import FileUpload from "../../../components/FileUpload/FileUpload";

interface BlockDataProp {
  blockData: VendorBlockinViewData;
  vendorDetailMode: VendorRequestViewMode;
}

export default function BlockData(props: BlockDataProp) {
  const classes = useStyles();
  const { blockData, vendorDetailMode } = props;

  const concateDataList = (datalist: any) => {
    if (datalist && datalist.length > 0) {
      let concatstring = datalist.join(",");
      return concatstring;
    }
    return "";
  };

  return (
    <div>
      <Grid
        container
        spacing={2}
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        className={classes.formOneWrapper}
      >
        <Grid item xs={12} sm={12} md={6} lg={4}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_block_blocking_co_lbl}
            </span>
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <span className={classes.textWrap}>{concateDataList(blockData.companyCodes)}</span>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_block_blocking_po_lbl}
            </span>
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <span className={classes.textWrap}>
              {concateDataList(blockData.poCodes)}
            </span>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={4}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_block_blocking_type_lbl}
            </span>
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <span className={classes.textWrap}>
              {concateDataList(blockData.typeOfBlocks) || 'Unblock'}
            </span>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={4}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {vendorDetailMode === VendorRequestViewMode.VendorBlock
                ? translation.vendor_block_blocking_reason_lbl
                : translation.vendor_block_unblocking_reason_lbl}
            </span>
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <span className={classes.textWrap}>
              {blockData.reasonForBlockDesc}
            </span>
          </Grid>
        </Grid>
        <Grid hidden={blockData.reasonForBlockId != DropdownOptions_VendorBlocing_Reason.blacklistedVendor} item xs={12} sm={12} md={6} lg={4}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <span className={classes.formTwoLbl}>
                {translation.vendor_block_blocking_reasonupload_lbl}
              </span>
            </Grid>
            <Grid
              className={classes.formOneinputWrapper}
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
            >
              <div className={classes.fileWrapper}>
                <FileUpload
                  editable={false}
                  requestNumber={""}
                  //onFileUpload = {(fileId:number) => { onFileUpload(fileId) }}
                  userfile={blockData?.blacklistProof!}
                  //userfile={blacklistProof}
                  attachmentType={FileUploadTypes.BlacklistProof}
                ></FileUpload>
              </div>
            </Grid>
          </Grid>
        <Grid hidden={!blockData.reasonForBlockOtherReason} item xs={12} sm={12} md={6} lg={4}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_block_blocking_reason_other_lbl}
            </span>
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <span className={classes.textWrap}>
              {blockData.reasonForBlockOtherReason}
            </span>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_block_blocking_paymentblock_lbl}
            </span>
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <span className={classes.textWrap}>
              {blockData.paymentBlockDesc}
            </span>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
